import React from "react"
import PropTypes from "prop-types"
import L10n from "lib/carrot-l10n"
import { getCompiler } from "utils/MarkdownCompile"
import { TextLink } from "./atoms/links/TextLink"
import { ButtonPrimary } from "./atoms/buttons/ButtonPrimary"
import { AvaCheckoutButton } from "./molecules/AvaCheckoutButton"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const elements = {
  h1({ id, children }) {
    return <h1 className="publico-headline b normal lh-title mt5 black-90">{children}</h1>
  },
  h2({ id, children }) {
    return <h2 className="b gotham black-80 mb2 mt4 f4">{children}</h2>
  },
  h3({ id, children }) {
    return <h3 className="b gotham black-80 mb2 mt4 f5">{children}</h3>
  },
  h4({ id, children }) {
    return <h4 className="b gotham black-80 mb2 mt4 f6">{children}</h4>
  },
  // ,
  // blockquote({ children }) {},
  hr({ id, children }) {
    return <hr className="w5-ns w4 mv4 center b--black-05" />
  },
  // ol({ children }) {},
  // ul({ children }) {},
  li({ children }) {
    return <li className="gotham lh-copy mv3">{children}</li>
  },
  p({ children }) {
    return <p className="lh-copy gotham black-80 mt0 mb3">{children}</p>
  },
  // table({ children }) {},
  // thead({ children }) {},
  // tbody({ children }) {},
  // tr({ children }) {},
  // th({ children }) {},
  // td({ children }) {}
  a({ href, title, target, children }) {
    return (
      <TextLink target={target} title={title} to={href}>
        {children}
      </TextLink>
    )
  },
  table({ children }) {
    return (
      <div className="overflow-x-auto">
        <table className="f5 v-top w-100 t--fixed collapse pv2 ph3 ba --moon-gray bg-black-05">{children}</table>
      </div>
    )
  },
  th({ children }) {
    return <th className="v-btm collapse pv2 ph3 ba b--moon-gray striped--pearl-lusta">{children}</th>
  },
  td({ children }) {
    return <td className="v-top collapse pv2 ph3 ba b--moon-gray striped--pearl-lusta">{children}</td>
  },
  blockquote({ children }) {
    return <blockquote>{children}</blockquote>
  }

  // ,
  // strong({ children }) {},
  // em({ children }) {},
  // br() {},
  // del({ children }) {},
  // img({ src, alt }) {},
  // code({ language, code }) {},
  // codespan({ children }) {}
}
const components = {
  Ava(props) {
    return (
      <>
        <AvaCheckoutButton ButtonComponent={ButtonPrimary} />
        <br />
      </>
    )
  },
  Chat(props) {
    return (
      <>
        <ButtonPrimary to="/talk-to-carrot/">{l`client.experts.chatWithAnExpert`}</ButtonPrimary>
        <br />
      </>
    )
  },
  BookTime(props) {
    return <ButtonPrimary to="/talk-to-carrot">{l`client.experts.bookTime`}</ButtonPrimary>
  },
  ReadMore(props) {
    return <TextLink to="/read">{l`client.content.readMore`}</TextLink>
  },
  BankInfo(props) {
    return <TextLink to="/account">{l`client.content.bankInfo`}</TextLink>
  }
}

const md = getCompiler(elements, components)

const DefaultMarkdown = ({ additionalClasses, source }) => (
  <div className={`m0-first-last-child ${additionalClasses ? additionalClasses : ""}`}>{md(source)}</div>
)

DefaultMarkdown.propTypes = {
  source: PropTypes.string.isRequired,
  additionalClasses: PropTypes.string
}
export { elements, components }

export default DefaultMarkdown
